<div class="page">
    <div class="page__header">
        <custom-app-bar
                [hasBackButton]="true"
        >
        </custom-app-bar>
    </div>

    <div class="page__content">
        <h1 class="header1">{{'login.title' |  translate}}</h1>
        <form id="login-form" (ngSubmit)='onSubmit()' [formGroup]="loginForm">

            <custom-form-field
                    type="email"
                    [label]="'login.email_placeholder' | translate"
                    controlName="email"
                    [formGroup]="loginForm">
            </custom-form-field>

            <custom-form-field
                    type="password"
                    [label]="'login.password_placeholder' | translate"
                    controlName="password"
                    [formGroup]="loginForm"
                    [passwordVisibilitySwitch]="(canDisplayPassword$ | async) ?? false"
            >
            </custom-form-field>

            <a [routerLink]="['/',routeNames.resetPassword] | localize" class="text text--forgotten-password">
                {{'login.forgotten_password' | translate }}
            </a>

            <button
                    customButton
                    [isLoading]="isLoginLoading$ | async"
                    [disabled]="(isLoginLoading$ | async) || loginForm.invalid"
                    type="submit"
                    appearance="flat"
                    expand="full"
                    size="large"
            >
                {{'login.button_login' | translate}}
            </button>
        </form>
    </div>

    <div class="page__footer">
        <p class="text text--centered">{{'login.dont_have_account' | translate}}</p>
        <button
                customButton
                appearance="ghost"
                expand="full"
                size="large"
                [routerLink]="['/', routeNames.signUp] | localize"
        >
            {{'sign_up.button' | translate}}
        </button>
    </div>
</div>
